import { validate } from 'uuid';

export const isValidID = (uuidString: string) => {
  return validate(uuidString);
};
